!((document, Drupal) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.sidebarMenu = {
    attach: function (context) {
      const menu = context.querySelector('.l-sidebar__header .sidebar-menu');
      if (menu) {
        const sectionMenu = () => {
          const toggle = context.querySelector(
            '.l-sidebar__header .sidebar-menu__toggle'
          );
          const wrap = context.querySelector(
            '.l-sidebar__header .sidebar-menu__wrap'
          );
          toggle.addEventListener('click', () => {
            if (toggle.classList.contains('active')) {
              toggle.classList.remove('active');
              wrap.classList.remove('active');
            }
            else {
              toggle.classList.add('active');
              wrap.classList.add('active');
            }
          });
        };
        sectionMenu();
      }
    }
  };
})(document, Drupal);
